import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useStore } from '@mcn-platform/models';
import TabbedAuthDialog from './TabbedAuthDialog';
import ForgotPassword from './ForgotPassword';
const AuthGuard = ({ initialTab, header, children, }) => {
    const store = useStore();
    const [dialog, setDialog] = React.useState(initialTab);
    if (!store.isAnonymous) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return (_jsx(_Fragment, { children: children }));
    }
    if (dialog === 'NONE') {
        return null;
    }
    if (dialog === 'FORGOT-PASSWORD') {
        return (_jsx(ForgotPassword, { open: true, handleClose: () => {
                setDialog('NONE');
            }, showSignIn: () => { setDialog('SIGN-IN'); }, showSignUp: () => { setDialog('SIGN-UP'); } }));
    }
    return (_jsx(TabbedAuthDialog, { open: true, initialTab: initialTab, header: header, handleClose: () => {
            setDialog('NONE');
        }, showForgotPassword: () => {
            setDialog('FORGOT-PASSWORD');
        } }));
};
export default AuthGuard;
//# sourceMappingURL=AuthGuard.js.map